import { smetaModals } from "../../MainPage/Tools/modalManager";
import React from "react";
import { getModalSectionID, getStyleWindow } from "../../MainPage/Tools/Tools";
import { GetDialogParam, resumeRequest } from "../TokenProcessing";
import HandleTable from "./HandleTable";

interface Data {
  json: {
    Params: {
      ObjType?: string;
      Module?: string;
      ObjRef?: string;
      RequestID?: string;
      OnlyView?: string;
      MultiSel?: string;
      Level?: string;
      Code?: string;
      RecordIndex?: string;
      Title?: string;
    };
    CLSID?: string;
    Title?: string;
    Module?: string;
  };
  subData: {
    props: any;
    func: (data: any) => any;
    from: string;
  };
  requestID: string;
}

export const editDocumentField = (data: Data) => {
  const { json, subData, requestID } = data;
  if (json.Params) {
    const DialogParam = GetDialogParam(subData.props.ObjType, subData.props.Module, subData.props.ObjRef, requestID);

    const subDataProps = {
      props: {
        ...subData.props,
        RequestID: requestID,
        SectionID: getModalSectionID(),
        func: subData.func,
        from: subData.from,
        addInfo: {
          ...subData.props.addInfo,
          needPost: true,
        },
      },
    };

    smetaModals.open(<HandleTable json={DialogParam} subData={subDataProps} />, {
      Title: DialogParam.Title,
      style: getStyleWindow(DialogParam.CLSID),
      onClose: () => {
        subData.props?.input?.current?.focus();
        resumeRequest(requestID, subData, {});
      },
      callBacks: true,
    });
  }
};
